<template>
    <div class="pcPage">
        <div class="loginCon">
            <div class="nologin" v-if="!getUserInfo.isLogin">
                <span class="btn" @click="loginFun">注册</span><span>|</span><span class="btn" @click="loginFun">登录</span>
            </div>
            <div class="islogin" v-if="getUserInfo.isLogin">
                <span class="btn" @click="loginOut">退出</span><span>|</span><span>{{getUserInfo.username}}</span>
            </div>
        </div>
        <div class="header">
            <img src="../img/banner.png" alt="" class="banner">
            <img src="../img/celc.png" alt="" class="logo">
        </div>
        <!-- <div class="tab">
            <div class="container">
                <router-link to="/pcpage/home">
                    <div>
                        首页
                    </div>
                    <div>
                        HOME
                    </div>
                </router-link>
                <router-link to="/pcpage/noticelist/notice">
                    <div>
                        比赛规则
                    </div>
                    <div>
                        RULES
                    </div>
                </router-link>
                <router-link to="/pcpage/submitlist">
                    <div>
                        作品提交
                    </div>
                    <div>
                        SUBMIT
                    </div>
                </router-link>
                <router-link to="/pcpage/list">
                    <div>
                        作品展示
                    </div>
                    <div>
                        GALLERY
                    </div>
                </router-link>
                <router-link to="/pcpage/skill">
                    <div>
                        摄影技巧
                    </div>
                    <div>
                        TECHNIQUES
                    </div>
                </router-link>
            </div>
            
        </div> -->
        <router-view></router-view>
        <div class="copyRight">
            <div>
                <img src="../img/celc_logo.png" alt="" class="logo">
            </div>
            <div class="footerMessage">
                主办单位：中外语言交流合作中心
            </div>
            <div class="footerMessage">
                <span>
                地址：北京市西城区德胜门外大街<span  class="num">129</span>号 邮编: <span  class="num">100088</span></span>
            </div>
            <div>
                <div  class="footerMessage">
                版权所有： 中外语言交流合作中心  <a  href="http://beian.miit.gov.cn">京ICP 备 <span class="num">08002516-8</span></a></div>
            </div>
        </div>

        <!-- <div class="review_con">
          <img src="../img/review_logo.png" alt="">
        </div> -->

        <div class="tip" v-if="tip">
            <img src="../img/activity_tip.png" alt="">
            <div class="uploadTip" @click="routerTo('/pcpage/submitlist')">
                立即上传
            </div>
            <img src="../img/close_tip.png" alt="" class="close" @click="tip = false">
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'pcpage',
    data: function () {
        return {
            tip: true
        }
    },
    computed: {
    ...mapGetters(['getUserInfo']),
    },
    mounted() {
        this.checkLogin()
    },
    methods: {
        ...mapActions(['setUserInfoAction']),
        // 检查登录状态
        checkLogin () {
        this.$utils.get('/user/checkLogin', { withinfo: 1 }).then(res => {
            if (res.code === 1000) {
            this.setUserInfoAction({
                isLogin: true,
                username: res.data.username,
                volunteer_info: res.data.volunteer_info
            })
            if(res.data.volunteer_info == 0) {
                if(this.$route.path.indexOf('submitlist')) {
                  //   this.$router.push('/pcpage/userinfo')
                }
            }
            } else {
            this.setUserInfoAction({
                isLogin: false,
                username: '',
                volunteer_info: 0
            })
            // this.loginFun()
            }
        })
        },
        routerTo(url) {
            this.$router.push({
                path: url,
            })
        },
        // 登录
        loginFun () {
        const currentUrl = window.location.href
        window.location.href = 'https://collection2021.chineseplus.net/user/login?callback=' + encodeURIComponent(currentUrl)
        },
        // 退出登录
        loginOut () {
        this.$utils.get('/user/logout', { }).then(res => {
            if (res) {
            window.location.reload()
            }
        })
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pcPage {
    width: 100%;
    min-height: 100%;
    min-width: 1200px;
    position: relative;
    font-family: 'Microsoft YaHei';
    font-size: 0;
    background-image: url(../img/bg.png);
    background-size: cover;
    background-repeat: repeat;
    .loginCon {
        font-size: 18px;
        height: 50px;
        line-height: 50px;
        background-color: #fff;
        .nologin,.islogin {
            width: 1200px;
            margin: auto;
            span {
                float: right;
                margin-left: 15px;
            }
            .btn {
                cursor: pointer;
            }
        }
        
    }
    .header {
        width: 100%;
        position: relative;
        .banner {
            width: 100%;
        }
        .logo {
            position: absolute;
            bottom: 4%;
            left: 0;
            right: 0;
            margin:  0 auto;
        }
    }
    .tab {
        width: 100%;
        height: 80px;
        background-color: rgba(#fff, 0.7);
        background-image: url(../img/tab_bg.png);
        background-repeat: no-repeat;
        
        .container {
            width: 1200px;
            height: 100%;
            margin: auto;
            a {
                vertical-align: top;
                display: inline-block;
                text-align: center;
                width: 20%;
                height: 80px;
                line-height: 1.6;
                font-size: 32px;
                color: #0b2ab0;
                div:last-child {
                    font-size: 20px;
                    line-height: 1.2;
                }
            }
            .router-link-active {
                background-color: #9576ef;
                color: #fff;
            }
        }
    }
    .copyRight {
        // position: absolute;
        bottom: 0px;
        left: 0;
        text-align: center;
        font-size: 20px;
        color: #a38fe9;
        margin-top: 30px;
        padding-bottom: 32px;
        right: 0;
        margin: 30px auto 0;
        background-color: #031e5d;
        padding: 33px 0;
        color: hsla(0,0%,100%,.6);
        font-size: 14px;
        .logo {
            width: 60px;
            margin: 0 auto 20px;
        }
        .footerMessage {
            margin-bottom: 10px;
            a {
                color: #c9bc9c;
            }
        }
    }
    .tip {
        position: fixed;
        right: 20px;
        z-index: 5;
        top: 300px;
        top: 200px;
        .uploadTip {
            position: absolute;
            bottom: 30px;
            font-size: 24px;
            left: 0;
            color: #fff;
            border-radius: 30px;
            text-align: center;
            right: 0;
            margin: auto;
            background-color: rgb(75, 77, 240);
            box-shadow: 0px 0px 16px 0px rgba(116, 116, 116, 0.5);
            position: absolute;
            width: 267px;
            height: 48px;
            line-height: 48px;
            cursor: pointer;
        }
        .close {
            position: absolute;
            bottom: -40px;
            left: 0;
            right: 0;
            margin: auto;
            cursor: pointer;
        }
    }
    .review_con {
      position: fixed;
      right: 20px;
      top: 65px;
      z-index: 5;
    }
}
</style>
